import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { Obra } from 'src/app/models/entities/obra';
import { ObraService } from 'src/app/services/obra.service';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { Estado } from 'src/app/models/entities/estado';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { LevantamientoObra } from 'src/app/models/entities/levantamiento-obra';
import { LevantamientoObraService } from 'src/app/services/levantamiento-obra.service';

@Component({
  selector: 'formato-pdf-presupuestos-estado',
  templateUrl: './formato-pdf-presupuestos-estado.component.html',
  styleUrls: ['./formato-pdf-presupuestos-estado.component.scss']
})
export class FormatoPdfPresupuestosEstadoComponent implements OnInit {

  @Output()
  public enviarRegistroListener: EventEmitter<ObraDTO> = new EventEmitter<ObraDTO>();

  @Input('datosPresupuestos')
  public datosPresupuestos: any;
  public catUnidadesResponsables: UnidadResponsable[] = [];
  public catalogoTipoObra: ElementoCatalogo[] = [];
  public catalogoPrioridad: ElementoCatalogo[] = [];
  public estados: Estado[] = [];
  public anioActual: number = new Date().getFullYear();
  public diaActual: number;
  public mesActual: number;

  public presupuestosRurales: PresupuestoEstado[] = [];
  public presupuestosFederales: PresupuestoEstado[] = [];
  public presupuestosFederalesFiltrados: PresupuestoEstado[] = [];
  public sumasPresupuestosFederales: any;
  public sumasSubTotalFederales: any;
  public urEstado: any;
  public caminosRuralesAlimentadores: PresupuestoEstado[] = [];
  public sumasCaminosRuralesAlimentadores: any;
  public programasRurales: PresupuestoEstado[] = [];
  public derechoDeViaFederales: PresupuestoEstado;
  public estudiosProyectosFederales: PresupuestoEstado;
  public sumasProgramasRurales: any;
  public sumasSubtotalRurales: any;
  public sumaTotal: any;

  public informacionCargada: boolean = false;
  public nombresMeses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];

  public readonly ESTUDIOS_Y_PROYECTOS: string = "Programa de Estudios y Proyectos de Caminos Rurales y Alimentadores 2020";
  public readonly CONSERVACION_INFRAESTRUCTURA: string = "Programa de Conservación de Infraestructura de Caminos Rurales y Carreteras 2020";
  public readonly DERECHO_DE_VIA: string = "LIBERACIÓN DE DERECHO DE VÍA";
  public readonly ESTUDIOS_Y_PROYECTOS_FEDERALES: string = "ESTUDIOS Y PROYECTOS DE CONSTRUCCIÓN DE CARRETERAS";

  datosEjemplo: any = {
    tipoPago: 'PEF',
    anio: 2020,
    estado: 'Baja California',
    construccion: {
      PEF: 138.7,
      meta: '-',
      autorizadoMod: 138.7,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    obras: [
      {
        id: 1,
        SHCP: 18096220001,
        carretera: 'Puentes Vehiculares del Cruce Fronterizo Mexicali – RíoNuevo',
        PEF: 97.4,
        meta: '0.6 de PSV',
        autorizadoMod: 97.4,
        tramitePago: 0,
        SIA: 0,
        SIAFF: 0,
        total: 0
      },
      {
        id: 2,
        SHCP: 18096220004,
        carretera: '(San Felipe – Laguna Chapala) Puertecitos – Laguna Chapala',
        PEF: 41.3,
        meta: '0.4 de Entr',
        autorizadoMod: 41.3,
        tramitePago: 0,
        SIA: 0,
        SIAFF: 0,
        total: 0
      }
    ],
    derechoVia:
    {
      PEF: 0,
      meta: '-',
      autorizadoMod: 0,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    estudios:
    {
      PEF: 0,
      meta: '-',
      autorizadoMod: 0,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    subtotal:
    {
      PEF: 145.6,
      meta: '-',
      autorizadoMod: 145.6,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    conservacionCaminosRurales:
    {
      PEF: 83.0,
      meta: '41.0',
      autorizadoMod: 83.0,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    estudiosCaminosRurales:
    {
      PEF: 5.0,
      meta: '21.0',
      autorizadoMod: 5.0,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    subtotalFinal:
    {
      PEF: 88.0,
      meta: '62.0',
      autorizadoMod: 88.0,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    },
    total:
    {
      PEF: 233.6,
      meta: '62.0',
      autorizadoMod: 233.6,
      tramitePago: 0,
      SIA: 0,
      SIAFF: 0,
      total: 0
    }
  }

  constructor(
    private catalogoService: CatalogoService,
    private obraService: ObraService,
    private facadeSesionService: FacadeSesionService,
    private levantamientoObraService: LevantamientoObraService
  ) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    await this.obtenerDatos();
    await this.obtenerSumasCarreteras();
    await this.obtenerSumasAlimentadores();
    await this.obtenerSumasProgramas();
    await this.obtenerSumaSubtotalFederales();
    await this.obtenerSumaSubtotalRurales();
    await this.obtenerSumaTotal();
    this.informacionCargada = true;
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
    this.catalogoTipoObra = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.TIPOS_OBRAS).pipe(take(1)).toPromise();
    this.catalogoPrioridad = await this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.PRIORIDAD).pipe(take(1)).toPromise();
    this.estados = await this.catalogoService.obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS).pipe(take(1)).toPromise();
  }

  public async obtenerDatos() {
    let dateRurales = new Date(this.datosPresupuestos.fechaCreacionRurales).getTime();
    let dateFederales = new Date(this.datosPresupuestos.fechaCreacionFederales).getTime();
    if (dateRurales < dateFederales) {
      this.diaActual = new Date(this.datosPresupuestos.fechaCreacionFederales).getUTCDate();
      this.mesActual = new Date(this.datosPresupuestos.fechaCreacionFederales).getUTCMonth();
    } else {
      this.diaActual = new Date(this.datosPresupuestos.fechaCreacionRurales).getUTCDate();
      this.mesActual = new Date(this.datosPresupuestos.fechaCreacionRurales).getUTCMonth();
    }
    this.urEstado = this.datosPresupuestos.urEstado;
    this.presupuestosRurales = this.datosPresupuestos.presupuestosRurales;
    this.presupuestosFederales = this.datosPresupuestos.presupuestosFederales;
    this.derechoDeViaFederales = this.presupuestosFederales.find((derechoVia: PresupuestoEstado) => derechoVia.nombreObra === this.DERECHO_DE_VIA);
    this.estudiosProyectosFederales = this.presupuestosFederales.find((derechoVia: PresupuestoEstado) => derechoVia.nombreObra === this.ESTUDIOS_Y_PROYECTOS_FEDERALES);
    this.presupuestosFederalesFiltrados = this.presupuestosFederales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra !== this.DERECHO_DE_VIA);
    this.presupuestosFederalesFiltrados = this.presupuestosFederalesFiltrados.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra !== this.ESTUDIOS_Y_PROYECTOS_FEDERALES);
    this.programasRurales = this.presupuestosRurales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra === this.ESTUDIOS_Y_PROYECTOS || presupuesto.nombreObra === this.CONSERVACION_INFRAESTRUCTURA);
    this.caminosRuralesAlimentadores = this.presupuestosRurales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra !== this.ESTUDIOS_Y_PROYECTOS && presupuesto.nombreObra !== this.CONSERVACION_INFRAESTRUCTURA);
  }

  public async obtenerSumasCarreteras() {
    let sumasPresupuestosFederales: any = {};
    sumasPresupuestosFederales.sumaPEF = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.pef, 0);
    sumasPresupuestosFederales.sumaMeta = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.metaPef, 0);
    sumasPresupuestosFederales.sumaModificado = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    sumasPresupuestosFederales.sumaTramitePago = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.ejercidoEnTramite, 0);
    sumasPresupuestosFederales.sumaEjercidoSIA = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
    sumasPresupuestosFederales.sumaEjercidoSIAFF = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
    sumasPresupuestosFederales.sumaTotalEjercido = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    sumasPresupuestosFederales.sumaSubejercido = this.presupuestosFederalesFiltrados.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
    this.sumasPresupuestosFederales = sumasPresupuestosFederales;
  }

  public async obtenerSumasAlimentadores() {
    let sumasAlimentadores: any = {};
    sumasAlimentadores.sumaPEF = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.pef, 0);
    sumasAlimentadores.sumaMeta = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.metaPef, 0);
    sumasAlimentadores.sumaModificado = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    sumasAlimentadores.sumaTramitePago = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.ejercidoEnTramite, 0);
    sumasAlimentadores.sumaEjercidoSIA = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
    sumasAlimentadores.sumaEjercidoSIAFF = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
    sumasAlimentadores.sumaTotalEjercido = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    sumasAlimentadores.sumaSubejercido = this.caminosRuralesAlimentadores.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
    this.sumasCaminosRuralesAlimentadores = sumasAlimentadores;
  }

  public async obtenerSumasProgramas() {
    let sumasProgramas: any = {};
    sumasProgramas.sumaPEF = this.programasRurales.reduce((prev, curr) => prev + curr.pef, 0);
    sumasProgramas.sumaMeta = this.programasRurales.reduce((prev, curr) => prev + curr.metaPef, 0);
    sumasProgramas.sumaModificado = this.programasRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    sumasProgramas.sumaTramitePago = this.programasRurales.reduce((prev, curr) => prev + curr.ejercidoEnTramite, 0);
    sumasProgramas.sumaEjercidoSIA = this.programasRurales.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
    sumasProgramas.sumaEjercidoSIAFF = this.programasRurales.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
    sumasProgramas.sumaTotalEjercido = this.programasRurales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    sumasProgramas.sumaSubejercido = this.programasRurales.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
    this.sumasProgramasRurales = sumasProgramas;
  }

  public async obtenerSumaSubtotalFederales() {
    let sumasSubTotalFederales: any = {};
    sumasSubTotalFederales.sumaPEF = this.presupuestosFederales.reduce((prev, curr) => prev + curr.pef, 0);
    sumasSubTotalFederales.sumaMeta = this.presupuestosFederales.reduce((prev, curr) => prev + curr.metaPef, 0);
    sumasSubTotalFederales.sumaModificado = this.presupuestosFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    sumasSubTotalFederales.sumaTramitePago = this.presupuestosFederales.reduce((prev, curr) => prev + curr.ejercidoEnTramite, 0);
    sumasSubTotalFederales.sumaEjercidoSIA = this.presupuestosFederales.reduce((prev, curr) => prev + curr.ejercidoSia, 0);
    sumasSubTotalFederales.sumaEjercidoSIAFF = this.presupuestosFederales.reduce((prev, curr) => prev + curr.ejercidoSiaff, 0);
    sumasSubTotalFederales.sumaTotalEjercido = this.presupuestosFederales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    sumasSubTotalFederales.sumaSubejercido = this.presupuestosFederales.reduce((prev, curr) => prev + curr.calendarioVsTotalEjercido, 0);
    this.sumasSubTotalFederales = sumasSubTotalFederales;
  }

  public async obtenerSumaSubtotalRurales() {
    let subtotalRurales: any = {};
    subtotalRurales.sumaPEF = this.sumasCaminosRuralesAlimentadores.sumaPEF + this.sumasProgramasRurales.sumaPEF;
    subtotalRurales.sumaMeta = this.sumasCaminosRuralesAlimentadores.sumaMeta + this.sumasProgramasRurales.sumaMeta;
    subtotalRurales.sumaModificado = this.sumasCaminosRuralesAlimentadores.sumaModificado + this.sumasProgramasRurales.sumaModificado;
    subtotalRurales.sumaTramitePago = this.sumasCaminosRuralesAlimentadores.sumaTramitePago + this.sumasProgramasRurales.sumaTramitePago;
    subtotalRurales.sumaEjercidoSIA = this.sumasCaminosRuralesAlimentadores.sumaEjercidoSIA + this.sumasProgramasRurales.sumaEjercidoSIA;
    subtotalRurales.sumaEjercidoSIAFF = this.sumasCaminosRuralesAlimentadores.sumaEjercidoSIAFF + this.sumasProgramasRurales.sumaEjercidoSIAFF;
    subtotalRurales.sumaTotalEjercido = this.sumasCaminosRuralesAlimentadores.sumaTotalEjercido + this.sumasProgramasRurales.sumaTotalEjercido;
    subtotalRurales.sumaSubejercido = this.sumasCaminosRuralesAlimentadores.sumaSubejercido + this.sumasProgramasRurales.sumaSubejercido;
    this.sumasSubtotalRurales = subtotalRurales;
  }

  public async obtenerSumaTotal() {
    let sumaTotal: any = {};
    sumaTotal.sumaPEF = this.sumasSubTotalFederales.sumaPEF + this.sumasSubtotalRurales.sumaPEF;
    sumaTotal.sumaMeta = this.sumasSubTotalFederales.sumaMeta + this.sumasSubtotalRurales.sumaMeta;
    sumaTotal.sumaModificado = this.sumasSubTotalFederales.sumaModificado + this.sumasSubtotalRurales.sumaModificado;
    sumaTotal.sumaTramitePago = this.sumasSubTotalFederales.sumaTramitePago + this.sumasSubtotalRurales.sumaTramitePago;
    sumaTotal.sumaEjercidoSIA = this.sumasSubTotalFederales.sumaEjercidoSIA + this.sumasSubtotalRurales.sumaEjercidoSIA;
    sumaTotal.sumaEjercidoSIAFF = this.sumasSubTotalFederales.sumaEjercidoSIAFF + this.sumasSubtotalRurales.sumaEjercidoSIAFF;
    sumaTotal.sumaTotalEjercido = this.sumasSubTotalFederales.sumaTotalEjercido + this.sumasSubtotalRurales.sumaTotalEjercido;
    sumaTotal.sumaSubejercido = this.sumasSubTotalFederales.sumaSubejercido + this.sumasSubtotalRurales.sumaSubejercido;
    this.sumaTotal = sumaTotal;
  }


  public obtenerNombreEstado(keyUR: string): string {
    return this.catUnidadesResponsables.find((ur: any) => ur.cve == keyUR).nombreEstado;
  }

  public async enviarRegistro(registroSHCP: any) {
    let obraObs = await this.obraService.findByRegistro(parseInt(registroSHCP)).pipe(take(1)).toPromise();
    let obraLev = await this.levantamientoObraService.findByKey(obraObs.keyLevantamientoObra).pipe(take(1)).toPromise();
    let keyTipoPrioridad = obraObs.keyCatTipoPrioridad;
    let keyTipoObra = obraLev.keyCatTipoObra;
    let keyEstado = obraLev.keyCatEstado;
    let obraDto: ObraDTO = {
      nombreEstado: this.estados.find((e: Estado) => e.key === keyEstado).nombre,
      nombreObra: obraLev.nombreObra,
      nombreTipoObra: this.catalogoTipoObra.find((c: ElementoCatalogo) => c.key === keyTipoObra).nombre,
      nombreTipoPrioridad: this.catalogoPrioridad.find((c: ElementoCatalogo) => c.key === keyTipoPrioridad).nombre,
      nombreTramoLicitacion: obraLev.nombreTramoLicitacion,
      keyCatDireccionAdjunta: obraLev.keyCatDireccionAdjunta,
      obra: obraObs
    }
    this.enviarRegistroListener.emit(obraDto);
  }

}
